import styled from 'styled-components'

const ChartHeading = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.43;
  text-align: left;
  color: rgba(13, 21, 54, 0.8);
`

const TabsHolder = styled.div`
  background-color: var(--Dove);
  padding: 10px 16px 0;
  display: flex;
  height: 56px;
  margin-bottom: 1px;
  gap: 16px;
`

const Tab = styled.div`
  margin-right: ${({ last }) => (!last ? '16px' : '0')};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  //   gap:4px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${({ theme, active, alwaysActive }) =>
    alwaysActive || active
      ? theme.colors.interactive.azure2
      : theme.colors.text.text300};

  @media (max-width: 600px) {
    margin-right: ${({ last }) => (!last ? '12px' : '0')};
    max-width: 24vw;
  }
`
const TabNameSpan = styled.span`
  white-space: nowrap;
  text-align: center;
  padding: 8px;
  //   border: ${({ theme, active, alwaysActive }) =>
    active && !alwaysActive
      ? `solid 2px ${theme.colors.interactive.azure2}`
      : 'none'};
  border-bottom: ${({ theme, active, alwaysActive }) =>
    active || alwaysActive
      ? `solid 2px ${theme.colors.interactive.azure2}`
      : 'none'};
  border-radius: ${({ alwaysActive }) => (alwaysActive ? '0px' : '8px')};

  &:hover {
    // border-radius: 4px;
    background-color: #f0f1f5;
  }

  @media (max-width: 600px) {
    &:hover {
      background-color: unset;
    }

    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const NovelHeading = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  text-align: left;
  color: rgba(13, 21, 54, 0.8);
`

const AnalyticToolTipContainer = styled.div`
  margin-left: 24px;
  margin-top: 5px;
`

const ErrorText = styled.div`
  background-color: white;
  color: red;
  padding: 20px;
`
const InfoExpandText = styled.div`
  color: #098af1;
  cursor: pointer;
`
const RevenueTab = styled.div`
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
`
const RevenueCardContainer = styled.div`
  background-color: white;
  padding: 10px;
  margin-top: 5px;
`
const RevenueCardValue = styled.div`
  margin-top: 15px;
  font-size: 18px;
  font-weight: 600;
`
const RevenueCardTitle = styled.span`
  font-size: 16px;
`
const RevenueCardMobTitle = styled.span`
  font-size: 16px;
  margin-left: 20px;
  font-weight: 600;
`

const ToolTipContainerRight = styled.div`
  float: right;
`

const CollapseHelpContainer = styled.div`
  max-width: 800px;
  margin-top: 10px;
`
const CollapseListContainer = styled.ol`
  margin-left: 16px;
  margin-top: 10px;
`

const CollapseListContainerItems = styled.li`
  margin-top: 5px;
`

export {
  ChartHeading,
  TabsHolder,
  Tab,
  TabNameSpan,
  NovelHeading,
  AnalyticToolTipContainer,
  ErrorText,
  InfoExpandText,
  RevenueTab,
  RevenueCardContainer,
  RevenueCardValue,
  RevenueCardTitle,
  ToolTipContainerRight,
  RevenueCardMobTitle,
  CollapseHelpContainer,
  CollapseListContainer,
  CollapseListContainerItems
}
